export const ERROR_IMAGE_ID = "portal/m/gifting-cart/giftbox-gifting-cart.png";
export const DEFAULT_ERROR_MESSAGE = "Please try again later";
export const DEFAULT_ERROR_TITLE = "Some error occurred";
export const RETRY = "Retry";
export const LOGIN = "Login";
export const ERROR_SCREEN_RETRY_WAIT_TIME_SECS = 5;
export const BG_IMAGE_ID = "portal/m/gifting-cart/background-color-error-bg.png";

const PREFIX = "gifting-cart";
export const DATA_TEST_ID = {
    CONTAINER: `${PREFIX}-container`,
    IMAGE: `${PREFIX}-image`,
    ERROR_TITLE: `${PREFIX}-title`,
    ERROR_SUBTITLE: `${PREFIX}-subtitle`,
    ERROR_PRIMARY_ACTION: `${PREFIX}-primary-action`,
    ERROR_SECONDARY_ACTION: `${PREFIX}-secondary-action`,
};

export const GIFTING_CART_ERROR_TYPE = {
    DEFAULT: "DEFAULT",
    EMPTY_CART: "EMPTY_CART",
    NETWORK_ERROR: "NETWORK_ERROR",
    SESSION_EXPIRED: "SESSION_EXPIRED",
    TOO_MANY_REQUESTS: "TOO_MANY_REQUESTS",
};

export const buildErrorPagePropsForErrorType = ({
    primaryActionOnClick = () => {
        // do nothing
    },
    secondaryActionOnClick = () => {
        // do nothing
    },
}: {
    primaryActionOnClick?: () => void;
    secondaryActionOnClick?: () => void;
}) => {
    return {
        [GIFTING_CART_ERROR_TYPE.DEFAULT]: {
            title: "Something went wrong",
            subtitle: "Couldn't add items. Please try again",
            primaryAction: {
                text: "Explore gift options",
                variant: "tertiary" as const,
                onClick: primaryActionOnClick,
            },
        },
        [GIFTING_CART_ERROR_TYPE.EMPTY_CART]: {
            title: "Uh-oh! Your cart is empty.",
            subtitle: "Explore giftables to find the perfect gift.",
            primaryAction: {
                text: "Find Your Perfect Gift!",
                variant: "tertiary" as const,
                onClick: primaryActionOnClick,
            },
        },
        [GIFTING_CART_ERROR_TYPE.NETWORK_ERROR]: {
            title: "Some network error occurred",
            subtitle: "Please try again later",
            primaryAction: {
                text: "Retry",
                variant: "tertiary" as const,
                onClick: primaryActionOnClick,
            },
            secondaryAction: {
                text: "Close",
                variant: "secondary" as const,
                onClick: secondaryActionOnClick,
            },
        },
    };
};
